import type { ProductModelV2 } from '@develop/ia-api-library'
import type { RouteLocationNormalized } from '#vue-router'
import { SessionStorage } from '~/models'
import type { GA4Product } from '@/models/ga4-product'
import { PrescriptionVariant } from '@/models/prescription'

export const useGeneralTracking = createSharedComposable(() => {
  const lastPageBeforeCheckout = useSessionStorage<string | null>(SessionStorage.LastPageBeforeCheckout, null, {
    initOnMounted: true,
  })

  const { GA4_TRACKING_ID, triggerEvent, getContentGroupName, getGA4ProductObject } = useGoogleAnalytics()

  const GA4_PRESCRIPTION = {
    id: '00000000',
    name: 'Rezept',
    price: 0.0,
    quantity: 1,
  }

  const GA4_EPRESCRIPTION = {
    id: '00000000',
    name: 'E-Rezept',
    price: 0.0,
    quantity: 1,
  }

  const setLastPageBeforeCheckout = (route: RouteLocationNormalized) => {
    // TODO: why not this?
    // const isCart = route.meta.type === PageType.Cart
    // const isCheckout = route.meta.type === PageType.Checkout
    // if (isCart || isCheckout)
    //   return

    const checkoutLayouts = ['cart', 'checkout']
    const isCheckout = route.meta.layout ? checkoutLayouts.includes(route.meta.layout) : false

    if (isCheckout)
      return

    set(lastPageBeforeCheckout, route.fullPath)
  }

  const pageViewEvent = (route: RouteLocationNormalized) => {
    if (isClient) {
      const hotjar = useHotJar()
      // const tvsquared = useTvSquared()
      const fb = useFacebook()
      const ga = useGoogleAnalytics()
      const microsoft = useMicrosoft()
      const referrerStore = useReferrerStore()
      const url = useRequestURL()

      ga.init()?.then(() => {
        const pageObject = {
          page_title: document.title,
          page_location: `${url.origin}${route.fullPath}`,
          page_referrer: `${!referrerStore.referrer.includes('https://') ? url.origin : ''}${referrerStore.referrer}`,
        }

        ga.pageViewEvent(pageObject)
      })
      // // // TODO: write function to start carousel autplay

      // Try to init Hotjar (inside is checked if the user has accepted the Hotjar cookies)
      hotjar.init()

      // Try to triger page view event for TvSquared (inside is checked if the user has accepted the TvSquared cookies)
      // tvsquared.pageViewEvent()

      microsoft.init()?.then(() => microsoft.consentModeEvent())
      fb.init()?.then(() => fb.pageViewEvent())
    }
  }

  const addToCartEvent = (product: GA4Product | null, price: Number, isPrescriptionProduct: PrescriptionVariant | undefined = undefined) => {
    const route = useRoute()
    triggerEvent('add_to_cart', {
      currency: 'EUR',
      value: !isPrescriptionProduct ? price : 0,
      items: [!isPrescriptionProduct ? product : isPrescriptionProduct === PrescriptionVariant.REGULAR ? GA4_PRESCRIPTION : GA4_EPRESCRIPTION],
      send_to: GA4_TRACKING_ID,
      content_group: getContentGroupName(route.name),
    })
  }

  const removeFromCartEvent = (product: ProductModelV2 | null, price: Number, isPrescriptionProduct: PrescriptionVariant | undefined = undefined) => {
    const route = useRoute()
    triggerEvent('remove_from_cart', {
      currency: 'EUR',
      value: !isPrescriptionProduct ? price : 0,
      items: [!isPrescriptionProduct ? getGA4ProductObject(product) : isPrescriptionProduct === PrescriptionVariant.REGULAR ? GA4_PRESCRIPTION : GA4_EPRESCRIPTION],
      send_to: GA4_TRACKING_ID,
      content_group: getContentGroupName(route.name),
    })
  }

  return {
    pageViewEvent,
    addToCartEvent,
    removeFromCartEvent,
    lastPageBeforeCheckout,
    setLastPageBeforeCheckout,
  }
})
